import axios from 'axios';
import {
  setConfig,
  setDashboardFilters,
  setRefetchTokens,
  setSttStatus,
  setUser,
} from '../redux/actions/actions';
import store from '../redux/store';
import { getTokens, removeTokens } from './AuthenticationService';
import { enqueueSnackbar } from 'notistack';

const instance = axios.create();

instance.interceptors.request.use(
  async (config) => {
    const user = store.getState().user;
    if (!user || !user.isEditorUser) {
      return config;
    }

    const tokens = getTokens();

    const isTokenReq = typeof config.data === 'string' && config.data.includes('grant_type');

    if (tokens && tokens.accessToken && tokens.accessToken !== '' && !isTokenReq) {
      config.headers.Authorization = `Bearer ${tokens.accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // removeToken();
    // console.log('ERROR FROM AXIOS:', error, error.response);
    if (error.response && error.response.status === 401) {
      /*removeTokens();
      store.dispatch(setRefetchTokens(null));
      store.dispatch(setUser(null));
      store.dispatch(setConfig(null));
      store.dispatch(setSttStatus(null));
      store.dispatch(setDashboardFilters([]));*/
    } else if (error.response && error.response.status === 500) {
      enqueueSnackbar(`Prišlo je do napake na zalednem delu, prosimo kontaktirajte tehnično podporo.`, {
        variant: 'error',
      });

      if (error.response.id) {
        enqueueSnackbar(`Koda napake: ${error.response.id}`, {
          variant: 'error',
        });
      }
    }

    // const customEvent = new CustomEvent('axios-error', { detail: error.response });
    // // console.log(error.response);
    // document.dispatchEvent(customEvent);

    return Promise.reject(error);
  }
);

export default instance;
